import { FunctionComponent, h } from 'preact';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'preact/hooks';
import { useStore } from '../../helpers/use-store';

// TODO: add click outside to close option

interface Props {
	isOpen: boolean;
	bodyClassName?: string;
	className?: string;
	dataTestId?: string;
}

const Modal: FunctionComponent<Props> = ({ isOpen, bodyClassName, className, children, dataTestId }) => {
	const modalBoxRef = useRef(null);
	const [shouldRender, setShouldRender] = useState(isOpen);
	const { ariaStore } = useStore();

	useEffect(() => {
		if (isOpen) setShouldRender(isOpen);
		ariaStore.setIsModalOpen(isOpen);
	}, [isOpen]);

	const onAnimationEnd = () => {
		if (!isOpen) setShouldRender(isOpen);
	};

	return (
		shouldRender && (
			<div
				data-testid={dataTestId}
				className={classNames('modal', className, isOpen ? 'mount' : 'unmount')}
				onAnimationEnd={onAnimationEnd}
			>
				<div className={classNames('modal-box', bodyClassName)} ref={modalBoxRef}>
					{children}
				</div>
			</div>
		)
	);
};

export default Modal;
